import { render, staticRenderFns } from "./ModalEditShipping.vue?vue&type=template&id=a95a4ac6&scoped=true&"
import script from "./ModalEditShipping.vue?vue&type=script&lang=js&"
export * from "./ModalEditShipping.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditShipping.vue?vue&type=style&index=0&id=a95a4ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a4ac6",
  null
  
)

export default component.exports